export default {"src":"/_next/static/media/eye_24.4b24e21d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};